/**
 * Иконки кабинета v2 — линейные, как в макете (stroke 1.8, без фирменных логотипов).
 */
import type { CSSProperties } from 'react';

interface IconProps {
  size?: number;
  strokeWidth?: number;
  style?: CSSProperties;
}

function Svg({
  size = 18,
  strokeWidth = 1.8,
  style,
  children,
}: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flex: 'none', ...style }}
    >
      {children}
    </svg>
  );
}

export const IconHome = (p: IconProps) => (
  <Svg {...p}>
    <path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" />
  </Svg>
);
export const IconCard = (p: IconProps) => (
  <Svg {...p}>
    <rect x="3" y="6" width="18" height="13" rx="2" />
    <path d="M3 10h18M16 15h2" />
  </Svg>
);
export const IconCode = (p: IconProps) => (
  <Svg {...p}>
    <path d="M8 7l-5 5 5 5M16 7l5 5-5 5" />
  </Svg>
);
export const IconHelp = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.5V14M12 17.5v.01" />
  </Svg>
);
export const IconUser = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6" />
  </Svg>
);
export const IconPlus = (p: IconProps) => (
  <Svg strokeWidth={2} {...p}>
    <path d="M12 5v14M5 12h14" />
  </Svg>
);
export const IconCollapse = (p: IconProps) => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M9 4v16M16 10l-2 2 2 2" />
  </Svg>
);
export const IconExpand = (p: IconProps) => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M9 4v16M14 10l2 2-2 2" />
  </Svg>
);
export const IconGlobe = (p: IconProps) => (
  <Svg strokeWidth={1.9} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3z" />
  </Svg>
);
export const IconPlane = (p: IconProps) => (
  <Svg strokeWidth={1.9} {...p}>
    <path d="M21 3L3 10.5l7 2.5 2.5 7z" />
    <path d="M10 13l11-10" />
  </Svg>
);
export const IconCheck = (p: IconProps) => (
  <Svg strokeWidth={3} {...p}>
    <path d="M5 12l5 5 9-10" />
  </Svg>
);

/** Разделы ассистента — пути иконок из макета (Assistant.dc.html). */
export const SECTION_ICON_PATHS: Record<string, string> = {
  settings: 'M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1M15 4v4M9 10v4M17 16v4',
  'test-chat': 'M4 5h16v11H8l-4 4z',
  knowledge: 'M4 4h6a2 2 0 0 1 2 2v14a2 2 0 0 0-2-2H4zM20 4h-6a2 2 0 0 0-2 2v14a2 2 0 0 1 2-2h6z',
  channels:
    'M8 11l8-4M8 13l8 4M6 10a2 2 0 1 1 0 4a2 2 0 1 1 0-4M18 4a2 2 0 1 1 0 4a2 2 0 1 1 0-4M18 16a2 2 0 1 1 0 4a2 2 0 1 1 0-4',
  dialogs: 'M3 5h12v8H7l-4 3zM9 16h8l4 3v-9h-3',
  broadcasts: 'M3 10v4h4l6 4V6L7 10zM17 9a4 4 0 0 1 0 6',
};

export const IconSection = ({ id, ...p }: IconProps & { id: string }) => (
  <Svg {...p}>
    <path d={SECTION_ICON_PATHS[id] ?? ''} />
  </Svg>
);
export const IconLogout = (p: IconProps) => (
  <Svg {...p}>
    <path d="M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4M10 17l5-5-5-5M15 12H3" />
  </Svg>
);
